import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useFlag } from '@unleash/proxy-client-react';
import { getPriceVisibility, resolvePriceVisibilityPage } from '../utils/priceVisibility';

export function usePriceVisibility(auction, page, section) {
  const { user } = useSelector(state => state.authentication);
  const relatedDealers = useSelector(state => state.user.relatedDealers);
  const dealerProfile = useSelector(state => state.user.profile);
  const { pathname } = useLocation();
  const canSeeNegotiateExclusivelyDetailsPage = useFlag('canSeeNegotiateExclusivelyDetailsPage');
  const canSeeGuaranteedPurchaseDetailsPage = useFlag('canSeeGuaranteedPurchaseDetailsPage');

  const resolvedPage = resolvePriceVisibilityPage({ page, section, pathname });

  return useMemo(
    () =>
      getPriceVisibility(user, auction, relatedDealers, resolvedPage, {
        canSeeNegotiateExclusivelyDetailsPage,
        canSeeGuaranteedPurchaseDetailsPage,
      }, dealerProfile),
    [
      user,
      auction,
      relatedDealers,
      dealerProfile,
      resolvedPage,
      canSeeNegotiateExclusivelyDetailsPage,
      canSeeGuaranteedPurchaseDetailsPage,
    ]
  );
}
